export const TRIGGER_TARGETS = {
  CHILDREN: 'children',
  TOOLTIP: 'tooltip'
};
export const TRIGGER_EVENTS = {
  CLICK: 'click',
  HOVER: 'hover'
};
//# sourceMappingURL=consts.js.map